<template>
  <div v-if="budget">
    <v-app-bar elevation="0" color="white" style="margin-top: -3px">
      <v-btn :to="`/leads/${budget.lead.identifier_code}/budgets`" exact icon>
        <v-icon>mdi-arrow-left </v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ budget.lead.identifier_code }} • {{ version }}
      </v-toolbar-title>
    </v-app-bar>

    <iframe
      v-if="budget.external_url"
      id="frame"
      ref="frame"
      :src="source"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { show, finish } from "@/services/dna_budgets";

export default {
  mixins: [],

  components: {},

  props: {},

  data() {
    return {
      loading: false,
      budget: null,
    };
  },

  methods: {
    async load() {
      const response = await show(this.$route.params.id);

      this.budget = response.data.data;
    },

    async onMessage(e) {
      console.log("message", e);

      if (e.data.type === "budget-result") {
        console.log("budget sent", e.data);
        const response = await finish(this.budget.id, {
          response: e.data.detail,
        });
      }

      if (e.data.type === "exit") {
        console.log("exit", e.data);
        this.$router.push(`/leads/${this.budget.lead.identifier_code}/budgets`);
      }
    },
  },

  computed: {
    version() {
      if (!this.budget) {
        return "";
      }

      const parts = this.budget.external_id.split("-");

      return parts[2];
    },

    source() {
      if (!this.budget) {
        return "";
      }

      if (this.budget.status === "draw") {
        return `https://home-budget.projetox.online/budget/${this.budget.external_url}/edit`;
      }

      return `https://home-budget.projetox.online/budget/${this.budget.external_url}/costs`;
    },
  },

  created() {
    this.load();
  },

  mounted() {
    window.addEventListener("message", this.onMessage);
  },

  beforeDestroy() {
    window.removeEventListener("message", this.onMessage);
  },
};
</script>

<style lang="scss">
#frame {
  width: 100%;
  height: calc(100dvh - 136px);
}
</style>
